import VideoExplainer from './VideoExplainer'

export default VideoExplainer
